import React from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    termsContainer: {
        padding: '20px',
        maxWidth: '800px',
        margin: '0 auto',
        fontFamily: 'Arial, sans-serif',
        color: '#333',
        lineHeight: 1.6,
    },
    termsTitle: {
        fontSize: '2.5em',
        fontWeight: 'bold',
        textAlign: 'center',
        color: '#1b2a4e',
        marginBottom: '30px',
    },
    termsSection: {
        marginBottom: '30px',
    },
    appNotice: {
        backgroundColor: '#f4f7f9',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '5px solid #1b2a4e',
        marginBottom: '30px',
    },
    termsSubtitle: {
        fontSize: '1.5em',
        fontWeight: 'bold',
        color: '#1b2a4e',
        marginBottom: '10px',
    },
    termsText: {
        margin: '5px 0',
        textAlign: 'justify',
    },
    indent: {
        marginLeft: '1rem',
        display: 'block'
    },
});

const PrivacyPolicyES: React.FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.termsContainer}>
            <h1 className={classes.termsTitle}>Política de Privacidad</h1>

            <section className={classes.appNotice}>
                <h2 className={classes.termsSubtitle}>Adenda: Uso de Datos en la Aplicación Móvil</h2>
                <p className={classes.termsText}>
                    En el marco de la colaboración clínica con el <b>Parc Taulí</b> para el estudio y tratamiento de la depresión, la aplicación móvil de DigimEvo requiere el tratamiento de datos específicos para habilitar sus funciones asistenciales:
                </p>
                <p className={classes.termsText}>
                    <span className={classes.indent}>
                        • <b>Ubicación en segundo plano:</b> Recopilamos datos de localización exacta (GPS/Geofencing) incluso cuando la aplicación está cerrada o no se encuentra en uso. Estos datos se utilizan exclusivamente para monitorizar la movilidad del paciente y detectar indicadores clínicos de anhedonia o aislamiento social, permitiendo alertas tempranas al personal médico.
                    </span>
                    <span className={classes.indent}>
                        • <b>Acceso al uso del dispositivo:</b> Monitorizamos patrones de uso de aplicaciones instaladas para evaluar el bienestar digital del paciente como biomarcador de su estado anímico.
                    </span>
                    <span className={classes.indent}>
                        • <b>Transferencia a terceros:</b> Los datos mencionados son procesados por DigimEvo y transferidos a nuestros socios tecnológicos colaboradores (incluyendo <b>Evidenze</b>) bajo estrictos protocolos de seguridad y anonimización, con el único fin de proporcionar estadísticas clínicas al facultativo responsable.
                    </span>
                </p>
            </section>

            <p className={classes.termsText}>
                DigimEvo se toma muy en serio su privacidad y trata todos sus datos personales con mucho cuidado. Este documento establece la política de DigimEvo con respecto a la privacidad y la seguridad. Se recomienda que lea esta política detenidamente. Las palabras en mayúscula se definen en los Términos de servicio.
            </p>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>1. ¿Quién es DigimEvo?</h2>
                <p className={classes.termsText}>
                    DigimEvo Limited es una sociedad de responsabilidad limitada constituida y existente conforme a las leyes de España, con domicilio social en Travessera de les Corts 262, 12 2, Barcelona 08014.
                </p>
                <p className={classes.termsText}>
                    DigimEvo ha desarrollado una plataforma utilizada por los proveedores sanitarios para recopilar información de y/o proporcionar información a sus pacientes. DigimEvo no es un proveedor de atención médica y no filtra el contenido publicado por los proveedores de atención médica, ni selecciona ni filtra información específica que se muestra a los pacientes.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>2. La Ley Aplicable</h2>
                <p className={classes.termsText}>
                    DigimEvo Limited, por constitución como sociedad en España, está sujeta a la Ley de Protección de Datos de 2018, el Reglamento (UE) 679/2016 (GDPR) y el Reglamento de Privacidad en las Comunicaciones de 2011 al controlar o procesar datos en sus negocios.
                </p>
                <p className={classes.termsText}>
                    Sin embargo, el lugar donde vive y el lugar donde su proveedor de salud está constituido afecta las leyes de privacidad y protección de datos que pueden aplicarse al control o procesamiento de sus datos.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>3. DigimEvo como procesador de datos</h2>
                <p className={classes.termsText}>
                    DigimEvo almacenará y procesará datos personales en nombre de sus clientes, los proveedores de atención médica. Para este procesamiento, el proveedor de atención médica actuará como el "controlador de datos" en el sentido de la Ley de Protección de Datos de 2018 y el Reglamento (UE) 679/2016 (GDPR).
                </p>
                <p className={classes.termsText}>
                    DigimEvo también actúa a veces como procesador de datos cuando es responsable del procesamiento legal de datos personales. Los motivos legales por los que procesamos los datos personales pueden variar según los términos de nuestro negocio, pero en general confiamos en una variedad de bases legales para procesar, incluido el contrato, el consentimiento y la expectativa legítima. Consulte a su proveedor de atención médica, el controlador de datos, para conocer cómo pueden procesar sus datos personales y los términos de sus políticas de privacidad.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>4. DigimEvo como controlador de datos</h2>
                <p className={classes.termsText}>
                    En determinadas circunstancias, DigimEvo también puede procesar sus datos personales para sus propios fines, en cuyo caso DigimEvo será el "controlador de datos" de sus datos personales y responsable del procesamiento legal de estos datos personales. Puede oponerse a que se procesen sus datos; sin embargo, esto puede impedir que se le proporcionen nuestros servicios. Comuníquese con los datos de contacto a continuación si desea que dejemos de procesar sus datos.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>5. ¿Qué datos personales recopila y procesa DigimEvo?</h2>
                <p className={classes.termsText}>
                    Para hacer uso del Servicio, es necesario crear una cuenta personal. Para ello, debe ingresar cierta información sobre usted. Su nombre, sexo y dirección de correo electrónico son obligatorios; otros campos son opcionales, como teléfono o país de residencia.
                </p>
                <p className={classes.termsText}>
                    La información contenida en su cuenta no es visible para terceros. Para los pacientes, solo el proveedor de atención médica que haya sido autorizado por el paciente puede ver la información de su cuenta.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>6. Condiciones de servicio</h2>
                <p className={classes.termsText}>
                    Al utilizar el Servicio, el proveedor de atención médica comparte información educativa mediante prescripción de vídeo con los pacientes y los pacientes brindan comentarios al respecto. Esta información es privada entre el paciente y el proveedor de atención médica y solo es accesible si el paciente autoriza al proveedor de atención médica a acceder a los datos.
                </p>
                <p className={classes.termsText}>
                    DigimEvo almacena esta información en nombre del proveedor de atención médica. DigimEvo solo procesará la información del paciente para sus propios fines con el consentimiento del paciente. Una vez que el paciente haya dado su consentimiento, DigimEvo anonimizará la información del paciente y la compartirá con terceros autorizados.
                </p>
                <p className={classes.termsText}>
                    Si el paciente es menor de edad, se pedirá a los padres o tutores legales del paciente que den su consentimiento para el procesamiento descrito anteriormente.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>7. Cookies</h2>
                <p className={classes.termsText}>
                    Cuando usa DigimEvo, las cookies se guardan en su computadora. Las cookies son pequeños fragmentos de información (en forma de texto) que un servidor envía a su navegador (como Internet Explorer o Firefox) con la intención de que el navegador envíe esta información al servidor la próxima vez que un usuario haga uso del Servicio. Las cookies no pueden dañar su computadora ni los archivos guardados en ella.
                </p>
                <p className={classes.termsText}>
                    Cuando utiliza el Servicio, las cookies de origen se guardan en su computadora. Las cookies de origen son creadas por o para DigimEvo y DigimEvo las almacena en su computadora, y solo DigimEvo tiene acceso a estas cookies. DigimEvo utiliza estas cookies, por ejemplo, para recordar su información de inicio de sesión.
                </p>
                <p className={classes.termsText}>
                    Para recopilar datos sobre el uso del sitio web de DigimEvo (el sitio web de marketing, no la plataforma utilizada para acceder al Servicio), DigimEvo utiliza Google Analytics. Google Analytics almacena una cookie permanente en su computadora que posteriormente se utiliza para registrar su uso del sitio web. Luego, Google analiza estos datos y los resultados se entregan a DigimEvo. Esto permite a DigimEvo mejorar sus servicios a los clientes y visitantes del sitio.
                </p>
                <p className={classes.termsText}>
                    Puede configurar su navegador para que no reciba cookies la próxima vez que utilice el Servicio. Sin embargo, es posible que ya no pueda hacer un uso completo del sitio web de DigimEvo o de los servicios de inicio de sesión del portal que se ofrecen en línea.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>8. Los fines para los que DigimEvo procesa los datos personales</h2>
                <p className={classes.termsText}>
                    DigimEvo puede usar sus datos personales para los siguientes fines:
                    <br />
                    <span className={classes.indent}>
                        - Permitir que el proveedor de atención médica use el Servicio, incluida la gestión de los programas de prescripción de vídeo para pacientes, la gestión del cumplimiento de los pacientes con los programas de prescripción en vídeo y el intercambio de plantillas de programas de prescripción en vídeo con otros usuarios de DigimEvo.
                    </span>
                    <span className={classes.indent}>
                        - Permitir que el paciente utilice el Servicio, incluido el acceso a programas de prescripción de vídeo en el hogar proporcionados por el proveedor de atención médica, monitorear el cumplimiento y proporcionar comentarios al proveedor de atención médica.
                    </span>
                    <span className={classes.indent}>
                        - Para comunicarnos con usted sobre el Servicio y/u otros servicios de DigimEvo.
                    </span>
                    <span className={classes.indent}>
                        - Para configurar DigimEvo para su uso.
                    </span>
                    <span className={classes.indent}>
                        - Con fines de protección y para generar datos estadísticos anónimos.
                    </span>
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>9. Intercambio de datos</h2>
                <p className={classes.termsText}>
                    DigimEvo solo divulgará información médica a terceros cuando el proveedor de atención médica haya dado su consentimiento para que el tercero específico involucrado (por ejemplo, una compañía de seguros) reciba dicha información y si dicha información es anónima para proteger la privacidad del paciente.
                    <br />
                    DigimEvo solo proporcionará sus datos personales a terceros distintos a los establecidos en esta Política de Privacidad en los siguientes casos:
                    <br />
                    <span className={classes.indent}>
                        - Si está obligado a hacerlo en base al acuerdo con el proveedor de atención médica.
                    </span>
                    <span className={classes.indent}>
                        - Si está obligado a hacerlo en virtud de leyes, jurisprudencia y/o regulaciones nacionales o internacionales.
                    </span>
                    <span className={classes.indent}>
                        - Si DigimEvo lo considera necesario en defensa de sus propios derechos.
                    </span>
                    <span className={classes.indent}>
                        - Si ha dado permiso para hacerlo.
                    </span>
                    <br />
                    DigimEvo puede publicar testimonios, comentarios o reseñas de clientes en el sitio web, que pueden contener datos personales de proveedores de atención médica. DigimEvo obtendrá el consentimiento del proveedor de atención médica por correo electrónico antes de publicar el testimonio.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>10. Transferencias internacionales de datos</h2>
                <p className={classes.termsText}>
                    Como DigimEvo utiliza servidores localizados para almacenar sus datos personales, esto minimiza las transferencias de datos a países que pueden no proporcionar la protección adecuada por ley a sus datos personales. Para obtener una lista completa de los países aprobados por la Comisión Europea como "adecuados", haga clic aquí: https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/adequacy-protection-personal-data-non-eu-countries_en
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>11. Procesamiento de datos de comportamiento</h2>
                <p className={classes.termsText}>
                    DigimEvo utiliza servicios de análisis de terceros para ayudar a comprender el uso del Servicio por parte de los proveedores de atención médica. No se comparte información del paciente a través de estos servicios.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>12. Retención de datos</h2>
                <p className={classes.termsText}>
                    Todos los datos procesados por DigimEvo se conservarán durante periodos de acuerdo con la Política de Retención de Datos. Cuando un proveedor de salud cancela el servicio de DigimEvo, los datos personales almacenados se eliminarán o se conservarán de acuerdo con la Política de Retención de Datos de DigimEvo.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>13. Seguridad de los datos</h2>
                <p className={classes.termsText}>
                    DigimEvo toma las medidas técnicas y organizativas adecuadas para proteger sus datos personales contra la pérdida o cualquier forma de uso ilegal. Debido a la naturaleza médica de algunos de los datos personales, DigimEvo ha incorporado un nivel de seguridad muy alto.
                </p>
                <p className={classes.termsText}>
                    Para proteger la confidencialidad e integridad de sus datos personales, contamos con:
                    <br />
                    <span className={classes.indent}>- Políticas internas que mantienen sus datos privados y confidenciales.</span>
                    <span className={classes.indent}>- Cifrado de todas las comunicaciones entre DigimEvo y nuestros usuarios (http a través de SSL, correo electrónico a través de TLS).</span>
                    <span className={classes.indent}>- Cifrado de toda la información de salud del paciente en nuestra base de datos ("en reposo").</span>
                    <span className={classes.indent}>- Limitación del acceso a la información dentro de nuestra empresa al mínimo necesario.</span>
                    <span className={classes.indent}>- Uso de un centro de datos protegido electrónica y físicamente.</span>
                    <span className={classes.indent}>- Uso de un cortafuegos que bloquee el acceso de atacantes y usuarios no autorizados.</span>
                    <span className={classes.indent}>- Cierre de sesión automático de los proveedores de atención médica después de un cierto periodo de inactividad.</span>
                    <span className={classes.indent}>- Exigencia a todos nuestros usuarios de elegir contraseñas seguras.</span>
                    <span className={classes.indent}>- Uso de una CDN (red de distribución de contenido) de clase mundial que filtre posibles atacantes.</span>
                    <span className={classes.indent}>- Uso de sistemas de prueba y desarrollo de última generación.</span>
                    <span className={classes.indent}>- Uso de las mejores tecnologías de gestión de servidores de su clase.</span>
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>14. Su derecho a acceder o eliminar sus datos personales</h2>
                <p className={classes.termsText}>
                    Si desea acceder a sus datos personales que DigimEvo pueda haber almacenado, o si desea solicitar una copia de esos datos, o cambiar datos que no puede modificar usted mismo en su cuenta, puede enviar su solicitud a gdpr@digimevo.com. DigimEvo le proporcionará los datos personales en un plazo de 4 semanas. Si DigimEvo, por alguna razón, no puede satisfacer su solicitud, se lo informará lo antes posible.
                </p>
                <p className={classes.termsText}>
                    DigimEvo retendrá sus datos personales mientras su cuenta esté activa o según sea necesario para brindarle el Servicio, resolver disputas, hacer cumplir acuerdos o cumplir con cualquier obligación legal de acuerdo con la Política de Retención de Datos. Si desea eliminar su cuenta o solicitar que DigimEvo ya no utilice sus datos personales, puede contactarnos en gdpr@digimevo.com. Las solicitudes de retención y eliminación de datos de DigimEvo están sujetas a la ley, la defensa de reclamos legales u obligaciones legales, independientemente de la Política de Retención de Datos.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>15. La autoridad supervisora correspondiente</h2>
                <p className={classes.termsText}>
                    Si tiene una queja sobre la forma en que se controlan o procesan sus datos, primero debe comunicarse con su proveedor de salud. Si cree que esto no resuelve sus inquietudes sobre la forma en que se controlan o procesan sus datos, tiene derecho a presentar una queja ante la autoridad nacional de supervisión de su país.
                </p>
                <p className={classes.termsText}>
                    Si bien DigimEvo aplica la ley española debido a su constitución, la lista completa de organismos de supervisión europeos se puede encontrar aquí: https://edpb.europa.eu/about-edpb/board/members_en
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>16. Fecha de la política</h2>
                <p className={classes.termsText}>
                    Esta política está sujeta a revisión anual o cuando haya cambios en la ley de protección de datos y/o privacidad. Por lo tanto, esta política se modificará en el futuro. Cualquier modificación de la política se publicará en el sitio web de DigimEvo. Esta política se actualizó por última vez el 9 de marzo de 2026.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>17. Datos de contacto</h2>
                <p className={classes.termsText}>
                    Si tiene alguna pregunta, no dude en ponerse en contacto con nuestro responsable de protección de datos a través de gdpr@digimevo.com o en Travessera de les Corts 262, 12 2, esc B, 08014 Barcelona.
                </p>
            </section>
        </div>
    );
};

export default PrivacyPolicyES;